import './blacksheep/style';
import FormStructure from './blacksheep/form_structure';

export default FormStructure;